<section class="container-fluid px-0"
         style="background: url(assets/img/landing-new/db-devops-serverless/standard-quality-control-concept-m.jpg); background-position: right; background-size: cover">
    <div class=" mt-0 hero w-100 d-flex align-items-center">
        <div class="container ">
            <div class="row ">
                <div class="align-items-center col-lg-5 hero-text px-4">
                    <h1 class="text-white fw-bold">Protect Your Digital Assets With Our Security Compliance Services</h1>
                    <p class="text-white">Managing Compliance in cloud computing can be hard - evolving regulations, constant audits, and endless documentation make it even more complex. Simplify the process with our Security Compliance Services, ensuring robust security and automating compliance workflows!
                    </p>
                    <div class="hero-buttons">
                        <button class="btn-primary" (click)="openModal()">Get Started </button>
                    </div>
                    <ng-template #contactFormModal>
                        <app-contact-form [isModalOpen]="isModalOpen"
                                          (closeModal)="closeModal()"></app-contact-form>
                    </ng-template>
                    <div *ngIf="isModalOpen" class="modal-overlay" (click)="handleOverlayClick($event)">
                        <ng-container *ngTemplateOutlet="contactFormModal"></ng-container>
                    </div>
                </div>
            </div>
        </div>


    </div>
</section>

<div class="container-fluid ">
    <div class="container py-md-5">
        <div class="row ">
            <div class="col-md-6 m-0 p-0 text-right align-self-center">
                <img src="assets/img/landing-new/db-devops-serverless/Volmint Technologies - Your Trusted Partner For Security & Compliance Services.png"
                     class="img-fluid border-radius-10"
                     alt="Image">
            </div>
            <div class="col-md-6 ps-md-5 py-md-5 ">
                <h2 class=" fs-1 fw-bolder ">Volmint Technologies - Your Trusted Partner For Security & Compliance Services
                </h2>
                <p class="text-secondary">As the world goes digital, data security and compliance become the foremost concern for the users and service providers. Data breaches and dishonest practices are on the rise due to feeble security regulations. Volmint Technologies, one of the leading security and compliance audit consultants offers top-notch services designed especially not to just safeguard your business but also optimized for compliance.
                </p>
                <p class="text-secondary">
                    Whether it’s fortifying cloud based computing security infrastructure to conducting auditing and compliance in cloud computing, our tailored services ensure your organization’s integrity and success. With a team of seasoned professionals in IT consulting, DevSecOps services, and Compliance audits, we deliver high-end security frameworks that foster resilience and trust in your operations.

                </p>
                <p class="text-secondary">We strengthen business IT infrastructure with a proactive approach, identify vulnerabilities, mitigate risks, and implement solutions that increase overall operational efficiency. Let our experts design, implement, and manage solutions that reduce risks, improve operational efficiency, and maintain trust across stakeholders.
                </p>
            </div>
        </div>
    </div>
</div>
<div class="container-fluid ">
    <div class=" container py-5">
        <h2 class="   fw-bold justify-text"> Why Choose Volmint’s Security & Compliance Services</h2>
        <p class=" text-secondary">At Volmint Technologies, our DevSecOps services are designed to integrate
            security throughout the development process. We focus on three key areas: SAST integration, DAST
            integration, and Web security, ensuring your applications are secure from code to deployment.
        </p>
        <div class="row gy-3 pb-5 ">
            <ng-container  *ngFor="let item of whyChoose1; let i = index">
                <div class="col-md-4  px-2"      [ngClass]="{
    'col-md-8': i === 0 || i === 3,
    'col-md-4': i === 1 || i === 2
  }">
                    <div class="bg-white h-100 pt-3 blue-shadow">
                        <div class="d-flex align-items-center p-3  border-left    fw-bold "><i [ngClass]="item.icon" class="fs-1 brown-color"></i></div>
                        <div class="px-3 pb-3">
                            <h3 class="fs-5 my-2 fw-bold">{{ item.header }}</h3>
                            <p class="text-secondary justify-text">{{
                                    item.text
                                }}</p>
                        </div>

                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>

<div class="container-fluid ">
    <div class="container py-5">
        <h2 class="   fw-bold justify-text"><span class="brown-color"> Our Services  -</span>  Comprehensive Solutions for Your Security & Compliance Needs</h2>

        <div class=" row my-5 mx-auto my col-12 row">
            <div class="tab-titles col-md-4  px-0" *ngFor="let tab of tabs; let i = index">
                <button class="w-100 py-3 btn rounded-0"
                        [class.active]="i === selectedIndex"
                        (click)="selectTab(i)">
                    {{ tab.title }}
                </button>
            </div>
            <div class="tab-content row border mx-auto">
                <div class="col-md-5 p-6">
                    <img [src]="tabs[selectedIndex].content.img" alt="">
                </div>
                <div class="col-md-7 border-start p-4">
                    <h3 class="brown-color fw-semibold">
                        {{tabs[selectedIndex].title}}
                    </h3>
                    <p class="text-secondary">{{tabs[selectedIndex].paragraph}}</p>
                    <h4 class="brown-color fs-5 fw-semibold">{{ tabs[selectedIndex].content.heading }}</h4>
                    <p class="text-secondary">{{tabs[selectedIndex].content.detail}}</p>
                    <ul>
                        <li *ngFor="let item of tabs[selectedIndex].content.list">
                            <p class="text-secondary">
                                {{item}}
                            </p>
                        </li>
                    </ul>
                </div>

            </div>
        </div>
    </div>
</div>
<div class="container-fluid" style="background: #f0f0f0">
    <div class="container  py-md-5">
        <div class="row align-items-center">
            <div class="col-md-5 text-center text-md-start p-5">
                <h2 class="fw-bold">
                    Our Process - A Proven Pathway to Security and Compliance
                </h2>
                <img src="assets/img/landing-new/db-devops-serverless/Our Process - A Proven Pathway to Security and Compliance.png"
                     class="img-fluid border-radius-10"
                     alt="Image">
            </div>
            <div class="col-md-7 px-md-5">
                <div class="row  bg-white mb-3">
                    <div class="col-2 p-2 d-flex align-items-center">
                        <img class="img-fluid" src="assets/img/landing-new/db-devops-serverless/In depth analysis.png" alt="">
                    </div>
                    <div class="col-10 py-3">
                        <h3 class="fs-5 fw-bold">In-Depth Analysis</h3>
                        <p class="text-secondary">The Journey begins with an in-depth analysis of your current system, roadmap, and cloud infrastructure. The process helps us to understand the risk profile,  needs, and areas requiring improvements. </p>
                    </div>
                </div>
                <div class="row bg-white mb-3">
                    <div class="col-2 p-2 d-flex align-items-center">
                        <img  class="img-fluid"  src="assets/img/landing-new/db-devops-serverless/Strategy Development.jpg" alt="">

                    </div>
                    <div class="col-10 py-3">
                        <h3 class="fs-5 fw-bold">Strategy Development</h3>
                        <p class="text-secondary">Following the detailed analyses, we will design a tailored plan to address identified risks. This strategy includes recommendations for compliance measures, DevSecOps integration, and IT infrastructure enhancements.
                        </p>
                    </div>
                </div>
                <div class="row bg-white mb-3">
                    <div class="col-2 p-2 d-flex align-items-center">
                        <img  class="img-fluid"  src="assets/img/landing-new/db-devops-serverless/Implementation.jpg" alt="">

                    </div>
                    <div class="col-10 py-3">
                        <h3 class="fs-5 fw-bold">Implementation</h3>
                        <p class="text-secondary">The very next step after getting approval for the appropriate strategy is to execute it. We deploy robust solutions, cloud compliance audits, security automation tools, and advanced monitoring systems. </p>
                    </div>
                </div>
                <div class="row bg-white mb-3">
                    <div class="col-2 p-2 d-flex align-items-center">
                        <img  class="img-fluid"  src="assets/img/landing-new/db-devops-serverless/Monitoring & Optimization.png" alt="">

                    </div>
                    <div class="col-10 py-3">
                        <h3 class="fs-5 fw-bold">Monitoring & Optimization</h3>
                        <p class="text-secondary">After implementation and deployment, we will move to monitoring and optimization of security compliance services. Our team continuously identifies chances for optimization to ensure systems remain secure.</p>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>

<div class="container-fluid parallax3">
        <div class=" container py-5">
            <h2 class=" text-white  fw-bold justify-text"> Benefits of Choosing Volmint’s Security & Compliance Services</h2>
            <p class="text-white">At Volmint Technologies, our DevSecOps services are designed to integrate
                security throughout the development process. We focus on three key areas: SAST integration, DAST
                integration, and Web security, ensuring your applications are secure from code to deployment.
            </p>
            <div class="row gy-3 pb-5 ">
                <ng-container  *ngFor="let item of benifits; let i = index">
                    <div class="col-md-4  px-2"      [ngClass]="{
    'col-md-8': i === 0 || i === 3,
    'col-md-4': i === 1 || i === 2
  }">
                        <div class="bg-white h-100 pt-3 blue-shadow">
                            <div class="d-flex align-items-center p-3  border-brown-left    fw-bold "><i [ngClass]="item.icon" class="fs-1 blue-color"></i></div>
                            <div class="px-3 pb-3">
                                <h3 class="fs-5 my-2 fw-bold brown-color">{{ item.header }}</h3>
                                <p class="text-secondary justify-text">{{
                                        item.text
                                    }}</p>
                            </div>

                        </div>
                    </div>
                </ng-container>
            </div>
        </div>

</div>

<div class="container-fluid">
    <div class="container">
        <div class="row">
            <div class="col-12 col-lg-6">
                <div class="col-12 text-center text-lg-start">
                    <img src="assets/img/landing-new/mobile-development/faq.png" alt="Image" class="img-fluid w-50"/>
                    <p class="fs-1 fw-bold">Frequently Asked Questions</p>
                    <p class="text-muted">Have a question that is not answered? You can contact us at</p>
                    <p class="brown-color fw-bold">Email: <a href="mailto:support@volmint.com"
                                                                          class="text-decoration-underline blue-color">support@volmint.com</a>
                    </p>
                    <button type="submit"
                            class="brand-primary-bg border-0 color-white px-5 py-2 fs-6 mt-4 fw-bold hover-effect"
                            (click)="goTo('/faq')">
                        View All Faqs
                    </button>
                </div>
            </div>
            <div class="col-12 col-lg-6 mt-4">
                <div class="accordion" id="faqAccordion">
                    <div class="accordion-item shadow-lg border-0">
                        <h2 class="accordion-header" id="headingOne">
                            <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                <span class="fs-6 fw-bold" style="color: #4f689a;">
                                    <div class="row">
                                        <div class="col-1">
                                          <div class="encircled-icon float-start">
                                                <i class="fas fa-question fw-bold"></i>
                                          </div>
                                        </div>
                                        <div class="col-11 ps-4 ps-md-2">
                                        What types of businesses can benefit from your IT Consulting Services?
                                        </div>
                                    </div>
                                </span>
                            </button>
                        </h2>
                        <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                Our IT Consulting Services are designed to cater to businesses of all sizes and
                                industries, including startups, SMEs, and large enterprises. We specialize in providing
                                tailored solutions that meet the specific needs of various sectors, including finance,
                                healthcare, retail, and technology.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h2 class="accordion-header" id="headingTwo">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        <span
                            class="fs-6 fw-bold" style="color: #4f689a;">
                             <div class="row">
                                        <div class="col-1">
                                            <div class="encircled-icon float-start">
                                                <i class="fas fa-question fw-bold"></i>
                                            </div>
                                        </div>
                                        <div class="col-11 ps-4 ps-md-2">
                                     How do you ensure the security of our data during the consulting process?
                                 </div>
                             </div>
                            </span>
                            </button>
                        </h2>
                        <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                At Volmint Technologies, we prioritize data security throughout our consulting services.
                                We adhere to industry best practices and compliance standards, implementing robust
                                security measures to protect your sensitive information during assessments,
                                implementations, and ongoing support.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h2 class="accordion-header" id="headingThree">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                <span class="fs-6 fw-bold" style="color: #4f689a;">
                                    <div class="row">
                                        <div class="col-1">
                                            <div class="encircled-icon float-start">
                                                <i class="fas fa-question fw-bold"></i>
                                            </div>
                                        </div>
                                        <div class="col-11 ps-4 ps-md-2">
                                            What is the typical duration of an IT consulting engagement?
                                        </div>
                                    </div>
                                </span>
                            </button>
                        </h2>
                        <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                The duration of an engagement varies based on the project scope and complexity. We offer
                                flexible options, whether it’s a short-term project or a long-term partnership, and work
                                closely with you to establish a timeline that aligns with your business goals.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h2 class="accordion-header" id="headingFour">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                <span class="fs-6 fw-bold" style="color: #4f689a;">
                                    <div class="row">
                                        <div class="col-1">
                                            <div class="encircled-icon">
                                                <i class="fas fa-question fw-bold"></i>
                                            </div>
                                        </div>
                                        <div class="col-11 ps-4 ps-md-2">
                                          Can you help with ongoing support after the initial implementation?
                                        </div>
                                    </div>
                                </span>
                            </button>
                        </h2>
                        <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                Yes, we offer ongoing support and maintenance services following the initial
                                implementation of your IT solutions. Our team is dedicated to ensuring that your systems
                                remain optimized, secure, and aligned with your evolving business needs.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h2 class="accordion-header" id="headingFive">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                <span class="fs-6 fw-bold" style="color: #4f689a;">
                                    <div class="row">
                                        <div class="col-1">
                                            <div class="encircled-icon">
                                        <i class="fas fa-question fw-bold"></i>
                                            </div>
                                        </div>
                                        <div class="col-11 ps-4 ps-md-2">
                                           How do Time and Material-based contracts work?
                                        </div>
                                    </div>
                                </span>
                            </button>
                        </h2>
                        <div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingFive"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                Time and Material-based contracts allow you to pay for the actual time and resources
                                utilized during the project. This flexible engagement model is ideal for projects with
                                changing scopes, as it ensures you have the necessary expertise when needed while
                                controlling costs effectively.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid ums-bottom-bg ps-5 mt-5">
    <div class="container">
        <div class="row align-items-center py-5">
            <div class="col-md-10 col-12">
                <h1 class="text-white">Ready to Take Your Business Growth to the Next Level?</h1>
            </div>
            <div class="col-md-2 col-12">
                <button class="btn bg-white rounded-0 px-5 py-3 text-black fw-bold hover-effect"
                        (click)="goTo('/contact')">Contact Us
                </button>
            </div>
        </div>
    </div>
</div>
